import { atom } from "jotai";
import { DEFAULT_VENUE, type VenueId } from "@/config/contracts";

export const venueAtom = atom<VenueId>(DEFAULT_VENUE);
